import React, {useContext, useEffect, useState} from 'react';
import {useLocation, useNavigate, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import {IconBox, Type as T} from "@infobis/ui-styles-utils";
import cn from "classnames";

import {Service} from "@context/map/mutableStore";
import FieldService from "@context/map/fields/fieldsStore";

import MonitoringBackLink from "@modules/card/backLink/MonitoringBackLink";

import Container from "@elements/container/Container";
import List from "@elements/list/List";
import ItemList from "@elements/itemList/ItemList";
import Sticker from "@elements/sticker/Sticker";
import FlexLine from "@elements/flexLine/FlexLine";

import {Align, Color, Crop, Field} from "@baseTypes/baseType";

import st from "../detailsField/detailsField.module.scss";

import Tx from "@baseTypes/naming";
import { ApplicationContext } from "@pages/monitoring/map/MapPage";
import colors from "@infobis/ui-styles-utils/colors";

const EditField = (props: any) => {
  let serviceStatus: any = useContext(Service);
  let ctx = useContext(ApplicationContext)

  // let {
  //   mapContainerRef,
  //   listOfSelected: [selectedList, setSelectedList],
  //   mapMode: [mapMode, setMapMode],
  //   showOnMap: [showOnMap, setShowOnMap]
  // }: any = useOutletContext()
  
  let navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  let location = useLocation();
  let params = useParams();
  
  let {fieldId = ""} = params
  
  let [detailedFiled, setDetailedField] = useState({} as Field)
  
  useEffect(() => {
    if (fieldId && ctx?.pixiContext) {
      ctx?.pixiContext.updateState(state => ({...state,
        showOnMap: true,
        selectedGeoZones: fieldId.split(":")}))
    }
  }, [fieldId, ctx])
  
  
  useEffect(() => {
    
    let {fields, hashFields, type, options, meta} = FieldService
    if (fieldId) {
      let fieldData = hashFields[fieldId] || {};
      
      if (Object.entries(fieldData).length) {
        setDetailedField(fieldData)
      }
    }
  }, [fieldId, serviceStatus?.fieldUpdate.lastUpdate])
  
  const {
    name,
    area,
    dynamic,
    manualArea
  } = detailedFiled
  
  return (
    <Container
      blur={true}
      className={st.container}
      color={Color.White}
      style={{
        height: "100%",
        padding: "24px"
      }}
    >
      <MonitoringBackLink
        path={"/map/fields"}
        title={Tx.ChangeGeozone}
      />
      
      <Container
        className={st.content}
        style={{
          marginTop: "24px"
        }}
        radius={true}
      >
        <List>
          <ItemList>
            <Sticker
              blur={true}
              radius={true}
            >
              <List>
                <ItemList className={st.title}>
                  <FlexLine className={st.title__name}>
                    <IconBox icon={T.IconName.Analytics} color={colors.CONTROL_DEFAULT_ICON_ICON}
                             className={st.icon}/>
                    <div>{name}</div>
                  </FlexLine>
                  <FlexLine align={Align.SpaceBetween} className={st.title__area}>
                    <FlexLine>
                      {area?.toFixed(2)} Га
                    </FlexLine>
                    {manualArea ? <FlexLine>
                      (Указано в ручную)
                    </FlexLine> : null}
                  </FlexLine>
                </ItemList>
                
                {dynamic?.cropsInfo.cropData.map((crop: Crop) => {
                  const {
                    id,
                    reproduction,
                    color,
                    endDate,
                    varieties,
                    title
                  } = crop
                  return (
                    <ItemList>
                      <FlexLine className={st.colorTitle}>
                        <div className={cn(st.icon, st.square)} style={{background: `#${color}`}}/>
                        {title}
                      </FlexLine>
                      {varieties ? <FlexLine align={Align.SpaceBetween}>
                        <FlexLine>
                          Cорт
                        </FlexLine>
                        <FlexLine>
                          {varieties}
                        </FlexLine>
                      </FlexLine> : null}
                      {reproduction ? <FlexLine align={Align.SpaceBetween}>
                        <FlexLine>
                          Репродукция
                        </FlexLine>
                        <FlexLine>
                          {reproduction}
                        </FlexLine>
                      </FlexLine> : null}
                    </ItemList>
                  )
                })}
              </List>
            </Sticker>
          </ItemList>
        </List>
      </Container>
    </Container>
  )
}
export default EditField
